import { Box, VStack } from "@chakra-ui/react";
import { Text } from "@looksrare/uikit";
import { useTranslation } from "next-i18next";

export enum RewardsViewTab {
  YOUR_REWARDS = "YOUR_REWARDS",
  LEADERBOARD = "LEADERBOARD",
}

export const RewardsView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        position="absolute"
        backgroundImage="url('/images/textures/topography.svg')"
        pointerEvents="none"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        top={0}
        w="93dvw"
        h="1083px"
        zIndex={0}
      />
      <VStack gap={4} position="absolute" top="50%" left="50%" maxW={618} transform="translate(-50%, -50%)">
        <Text textStyle="display-01" textAlign="center">
          {t("Season {{number}} Complete", { number: 2 })}
        </Text>

        <Text textStyle="body" textAlign="center" color="text-02">
          {t(
            "The Season {{number}} airdrop claim is now closed. Any unclaimed YOLO tokens have been directed to the treasury for future initiatives.",
            { number: 2 }
          )}
        </Text>
      </VStack>
    </>
  );
};
